module.exports = __webpack_public_path__ + "img/form_customer.6543c5b4.svg";